import { render } from "./updatepwd.vue?vue&type=template&id=8ac537fe&scoped=true"
import script from "./updatepwd.vue?vue&type=script&lang=js"
export * from "./updatepwd.vue?vue&type=script&lang=js"

import "./updatepwd.vue?vue&type=style&index=0&id=8ac537fe&scoped=true&lang=css"

import exportComponent from "/Volumes/work/mywork/selecthouse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ac537fe"]])

export default __exports__